import React, { useEffect, useState } from "react";
//import { decode } from 'base-64'
import ModalContent from './ModalContent'
import config from '../../config'


const ModalPopup = ({ families, isOpen, onClose }) => {
  /*
  const [families, setFamilies] = useState([]);
  
  useEffect((e) => {
    fetch(config.apiURL,{ method:'POST', 
      body: JSON.stringify({ cid: config.cid, act: 'getFam' }),
      headers: new Headers({'Content-Type': 'application/json' })})
      .then(res => res.json())
      .then(data => setFamilies(JSON.parse(decode(data.f))))
      .catch((err) => { console.log(err) })
    },[])
    */
    
    if (!isOpen) return null;


  return (
    <div className="modal-overlay">
      <div className="modal-content">
      <ModalContent families={families}></ModalContent>

        <div class="col col-12" align="center"><button class="button" onClick={onClose}>COMENÇAR</button></div>
      </div>
    </div>
  );
};

export default ModalPopup;
